import { relative } from 'unenv/runtime/node/path/index'
import { createJoinUsRoute } from '../joinUsRoute'

export default [
  {
    path: '/:lang/',
    name: 'Home',
    component: () => import('@/pages/index.vue'),
    meta: {
      name: 'home.header.Home',
      pageCode: 'ERA.UC.HOME',
      middleware: ['report'],
      headerIsWhite: true,
    },
  },
  {
    path: '/:lang/client/',
    name: 'client',
    component: () => import('@/pages/client/index.vue'),
    meta: {
      name: 'client',
      pageCode: 'ERA.UC.CLIENT',
    },
  },
  {
    path: '/:lang/appdownload',
    name: 'AppDownload',
    component: () => import('@/pages/appdownload.vue'),
    meta: {
      name: 'AppDownload',
      pageCode: 'ERA.UC.APPDOWNLOAD',
      noHeader: true,
    },
  },
  {
    path: '/:lang/company/:id/',
    name: 'shopHome',
    component: () => import('@/pages/home/[id].vue'),
    meta: {
      name: 'shopHome',
      pageCode: 'ERA.UC.SHOP.HOME',
    },
  },
  {
    path: '/:lang/forwarder/:id/',
    name: 'forwarderShopHome',
    component: () => import('@/pages/home/[id].vue'),
    meta: {
      name: 'forwarderShopHome',
      pageCode: 'ERA.UC.SHOP.HOME.FORWARDER',
    },
  },
  {
    path: '/:lang/company-case-Details/:shopId/:caseId',
    name: 'shopHomeCase',
    component: () => import('@/pages/home/case/index.vue'),
    meta: {
      name: 'shopHomeCase',
      pageCode: 'ERA.UC.SHOP.HOME.CASE',
    },
  },
  {
    path: '/:lang/aboutus/',
    name: 'AboutUs',
    meta: {
      name: 'home.header.Company.AboutUs',
      pageCode: 'ERA.UC.ABOUTUS',
    },
    component: () => import('~/pages/aboutus.vue'),
  },
  {
    path: '/:lang/ForbesChina/',
    name: 'ForbesChina',
    meta: {
      name: 'ForbesChina',
      pageCode: 'ERA.UC.FORBESCHINA',
      noPc: true,
    },
    component: () => import('~/pages/ForbesChina/index.vue'),
  },
  // {
  //   path: '/:lang/contactus',
  //   name: 'contactus',
  //   meta: {
  //     name: 'home.header.Company.ContactUs',
  //     pageCode: 'ERA.UC.ContactUs',
  //   },
  //   component: () => import('~/pages/contactus.vue'),
  // },
  {
    path: '/:lang/sem',
    name: 'Sem',
    meta: {
      name: 'home.header.sem.index',
      pageCode: 'ERA.UC.SEM',
      headStyle: `position: relative`,
    },
    component: () => import('~/pages/sem/index.vue'),
  },
  {
    path: '/:lang/sem-success',
    name: 'TransferPage',
    meta: {
      name: 'home.header.sem.result',
      // headerStyle: 'normal',
      pageCode: 'ERA.UC.SEM.RESULT',
    },
    component: () => import('~/pages/sem/Result.vue'),
  },
  createJoinUsRoute({
    path: '/:lang/JoinUs',
    name: 'JoinUs',
    metaName: 'home.header.Company.JoinUs',
    pageCode: 'ERA.UC.JOIN_US',
    component: () => import('~/pages/JoinUs.vue'),
  }),
  createJoinUsRoute({
    path: '/:lang/membership/JoinUs',
    name: 'AppJoinUs',
    metaName: 'home.header.Company.AppJoinUs',
    pageCode: 'ERA.UC.AppJoinUs',
    noPc: true,
    component: () => import('~/pages/JoinUs.vue'),
  }),
  {
    path: '/:lang/finance/',
    name: 'JCPay',
    meta: {
      name: 'home.header.JCPay.name',
      pageCode: 'ERA.UC.FINANCE',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/finance-jcwallet/',
    name: 'JCPayWallet',
    meta: {
      name: 'home.header.JCPayWallet.name',
      pageCode: 'ERA.UC.FINANCE.JCWALLET',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/finance-jcpay/',
    name: 'JCPayPay',
    meta: {
      name: 'home.header.JCPayPay.name',
      pageCode: 'ERA.UC.FINANCE.JCPAY',
    },
    component: () => import('~/pages/finance/jcpay/index.vue'),
  },
  {
    path: '/:lang/finance-b2bsk/',
    name: 'JCPayB2bsk',
    meta: {
      name: 'home.header.JCPayB2bsk.name',
      pageCode: 'ERA.UC.FINANCE.B2BSK',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/finance-tcs/',
    name: 'JCPayTcs',
    meta: {
      name: 'home.header.JCPayTcs.name',
      pageCode: 'ERA.UC.FINANCE.TCS',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/finance-usd/',
    name: 'JCPayUsd',
    meta: {
      name: 'home.header.JCPayUsd.name',
      pageCode: 'ERA.UC.FINANCE.USD',
    },
    component: () => import('~/pages/finance/msk/index.vue'),
  },
  {
    path: '/:lang/finance-dfsp/',
    name: 'JCPayDfsp',
    meta: {
      name: 'home.header.JCPayDfsp.name',
      pageCode: 'ERA.UC.FINANCE.DFSP',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/finance-privacypolicy/',
    name: 'JCPayPrivacy',
    meta: {
      name: 'home.header.JCPayPrivacy.name',
      pageCode: 'ERA.UC.FINANCE.PRIVACYPOLICY',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/finance-termservice/',
    name: 'JCPayTerm',
    meta: {
      name: 'home.header.JCPayTerm.name',
      pageCode: 'ERA.UC.FINANCE.TERMSERVICE',
      noHeader: true,
    },
    component: () => import('~/pages/JCPay.vue'),
  },
  {
    path: '/:lang/JCInsurance/',
    name: 'JCInsurance',
    meta: {
      name: 'JCInsurance',
      pageCode: 'ERA.UC.TOOLS.JCBAO',
    },
    component: () => import('~/pages/JCInsurance/index.vue'),
  },
  {
    path: '/:lang/InsuranceForm/',
    name: 'InsuranceForm',
    meta: {
      name: 'InsuranceForm',
      pageCode: 'ERA.UC.InsuranceForm',
    },
    component: () => import('~/pages/JCInsurance/insuranceForm.vue'),
  },
  {
    path: '/:lang/search',
    name: 'GlobalSearch',
    meta: {
      name: 'GlobalSearch',
      pageCode: 'ERA.UC.GlobalSearch',
      noHeader: true,
      noPc: true,
    },
    component: () => import('~/pages/GlobalSearch.vue'),
  },
  {
    path: '/:lang/marketing/credit/',
    name: 'Credit',
    meta: {
      name: 'MARKETCREDIT',
      pageCode: 'ERA.UC.MARKETCREDIT',
    },
    component: () => import('~/pages/marketing/creditOrder.vue'),
  },
  {
    path: '/:lang/marketing/transaction/',
    name: 'Transaction',
    meta: {
      name: 'MARKETTRANSACTION',
      pageCode: 'ERA.UC.MARKETTRANSACTION',
    },
    component: () => import('~/pages/marketing/transaction.vue'),
  },
  {
    path: '/:lang/seaCategory',
    name: 'Tools',
    meta: {
      name: 'Tools',
      pageCode: 'ERA.UC.TOOLS',
      noPc: true,
    },
    component: () => import('~/pages/tools/index.vue'),
  },
  {
    path: '/:lang/tools/Container/SchedulePlan',
    name: 'SchedulePlan',
    meta: {
      name: 'SchedulePlan',
      pageCode: 'ERA.UC.TOOLS.SP',
    },
    component: () => import('~/pages/tools/index.vue'),
  },
  {
    path: '/:lang/tools/Container/ContainerTracking',
    name: 'ContainerTracking',
    meta: {
      name: 'ContainerTracking',
      pageCode: 'ERA.UC.TOOLS.CT',
    },
    component: () => import('~/pages/tools/index.vue'),
  },
  {
    path: '/:lang/tools/spotRate',
    name: 'SpotRate',
    meta: {
      name: 'SpotRate',
      pageCode: 'ERA.UC.TOOLS.SPOT.RATE',
    },
    component: () => import('~/pages/tools/index.vue'),
  },

  // 船期落地页
  {
    path: '/:lang/inquiry/freightinquiry',
    name: 'Inquiries',
    meta: {
      name: 'Inquiries',
      pageCode: 'ERA.UC.INQUIRIES',
    },
    component: () => import('~/pages/inquiries/index.vue'),
  },
  {
    path: '/:lang/inquiry/freightinquiry/more',
    name: 'InquiriyMore',
    meta: {
      name: 'InquiriyMore',
      pageCode: 'ERA.UC.INQUIRYMORE',
    },
    component: () => import('~/pages/inquiries/index.vue'),
  },
  {
    path: '/:lang/my-qrcode',
    name: 'MyQRCode',
    meta: {
      name: 'home.header.MyQRCode',
      pageCode: 'ERA.UC.MYQRCODE',
    },
    component: () => import('~/pages/my-qrcode/index.vue'),
  },
  {
    path: `/:lang/404`,
    name: '404',
    component: () => import('~/pages/404.vue'),
    meta: {
      title: '404页面',
      pageCode: 'ERA.UC.404',
      headerStyle: 'normal',
      layout: 'empty',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('~/pages/404.vue'),
    meta: {
      title: '404页面',
      pageCode: 'ERA.UC.404',
      headerStyle: 'normal',
      layout: 'empty',
    },
  },
]
